module.exports = __webpack_public_path__ + "src/assets/img/ic11.402e1b31.svg";